import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import nonRunnersReducer from './nonRunners/nonRunners.reducer';

export default function configureStore(initialState) {
    return createStore(
        nonRunnersReducer,
        initialState,
        applyMiddleware(thunk),
    );
}



// WEBPACK FOOTER //
// ./src/js/configureStore.js